import React from 'react'
import CheckboxField from 'uiComponents/input/checkbox/checkboxField'
import { useTranslation } from 'translations'

interface UserRoleSectionProps {
    isAdminGranted: boolean
    handleAdminClick: (granted: boolean) => void
}

export const UserRoleSection = ({ isAdminGranted, handleAdminClick }: UserRoleSectionProps) => {
    const { t } = useTranslation()
    return (
        <div className="user-role">
            <CheckboxField
                name="partner_admin"
                label={t('settings.users.form.userRole.adminLabel')}
                checked={isAdminGranted}
                onChange={(e) => handleAdminClick(e.target.checked)}
            />
            <span className="checkbox-explanation">{t('settings.users.form.userRole.adminExplanation')}</span>
        </div>
    )
}
